/* eslint-disable react/jsx-props-no-spreading */
import cities from '@/services/api/cities'
import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'
import Autocomplete from '../Base'
import Row from './Row'
import Chip from './Chip'

function City({ onSelect, selected, ...props }) {
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])

  const search = useCallback((async (name) => {
    try {
      setLoading(true)
      const { data } = await cities.list({ q: { name } })
      setList(data?.rows)
    } catch (e) {
      toast.error('Erro ao recuperar lista de cidades.')
    } finally {
      setLoading(false)
    }
  }), [])

  const handleSelect = useCallback((city) => {
    onSelect(city)
    setList([])
  }, [onSelect])

  return (
    <Autocomplete
      loading={loading}
      onSelect={handleSelect}
      selected={selected}
      list={list}
      onSearch={search}
      ItemComponent={Row}
      ChipComponent={
        selected
          ? () => <Chip item={selected} onRemove={() => onSelect(null)} />
          : null
      }
      inputAttrs={{ placeholder: 'Busque a cidade', disabled: Boolean(selected) }}
      {...props}
    />
  )
}

City.propTypes = {
  selected: PropTypes.objectOf(PropTypes.any),
  onSelect: PropTypes.func.isRequired,
}

City.defaultProps = {
  selected: null,
}

export default City
